export function windowWidth() {
  return window.innerWidth ||
    document.body.clientWidth ||
    document.documentElement.clientWidth;
}


export const mobileWidth = 1000;